import * as _ from 'lodash-es';

export class CloneUtils {
    static cloneDeep<T>(obj: T): T {
        return _.cloneDeep(obj);
    }
}
